import React from 'react';
import PropTypes from 'prop-types';
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts';

const TinyLineChart = ({ data, renderTooltip, xAxisKey, lines, height }) => (
  <ResponsiveContainer width="100%" height={height}>
    <LineChart data={data}>
      <CartesianGrid horizontal={false} stroke="rgba(0, 0, 0, 0.05)" />
      {lines.map(line => (
        <Line
          type={line?.type}
          dataKey={line?.dataKey}
          stroke={line?.stroke}
          strokeWidth={line?.strokeWidth}
        />
      ))}
      <XAxis dataKey={xAxisKey} height={1} tickLine={false} />
      <Tooltip content={renderTooltip} />
    </LineChart>
  </ResponsiveContainer>
);

TinyLineChart.propTypes = {
  data: PropTypes.array,
  height: PropTypes.number,
  lines: PropTypes.array,
  renderTooltip: PropTypes.func,
  xAxisKey: PropTypes.string,
};

TinyLineChart.defaultProps = {
  data: [],
  height: 75,
  lines: [],
  renderTooltip: undefined,
  xAxisKey: undefined,
};

export default TinyLineChart;
